import { NidInquiryStatusType } from "../../enums/index";
function getNidInquiryStatusText(type) {
  let result = "";
  switch (type) {
    case NidInquiryStatusType.All():
      result = "احراز هویت نشده";
      break;
    case NidInquiryStatusType.Accepted():
      result = "احراز هویت شده";
      break;
    case NidInquiryStatusType.ReadyForInquiry():
      result = "در انتظار احراز هویت";
      break;
    case NidInquiryStatusType.InProgress():
      result = "در انتظار احراز هویت";
      break;
    case NidInquiryStatusType.Rejected():
      result = "احراز هویت رد شده";
      break;
    default:
      result = "";
      break;
  }
  return result;
}
export default getNidInquiryStatusText;
